import { Drawer, StatusBadge, styled } from '@driftt/dds'

export const StyledDrawerContent = styled(Drawer.Content, {
  background: '$gray2',
  padding: '$2',
})

export const StyledStatusBadge = styled(StatusBadge, {
  whiteSpace: 'nowrap',
})
